// client/src/pages/NotFoundPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography, Button, Box } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const NotFoundPage = () => {
  return (
    <Container maxWidth="sm" sx={{ py: 10, textAlign: 'center' }}>
      <Box sx={{ color: 'text.disabled', mb: 2 }}>
        <SearchOffIcon sx={{ fontSize: 72 }} />
      </Box>
      <Typography variant="h3" fontWeight={800} gutterBottom>404</Typography>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        We couldn't find that page.
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        The link may be broken, or the page may have moved.
      </Typography>
      <Button component={Link} to="/" variant="contained" size="large">
        Back to Home
      </Button>
    </Container>
  );
};

export default NotFoundPage;
